import React from "react";

import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "animate.css";

const SkyNotification = {
  alertDefault,
  alertSuccess,
  alertInfo,
  alertWarning,
  alertError
};

function alertDefault(message) {
  store.addNotification({
    container: 'top-right',                   // where to position the notifications
    content: () => {
      return (
        <div className='flash flash-info'>
          {message}
        </div>
      );
    },                                        // skyframework flash alert
    animationIn: ["animated", "fadeIn"],      // animate.css classes that's applied
    animationOut: ["animated", "fadeOut"],    // animate.css classes that's applied
    width: 275,
    dismiss: {
      duration: 3000
    }
  });
}

function alertSuccess(message) {
  store.addNotification({
    container: 'top-right',                   // where to position the notifications
    content: () => {
      return (
        <div className='flash flash-success'>
          {message}
        </div>
      );
    },                                        // skyframework flash alert
    animationIn: ["animated", "fadeIn"],      // animate.css classes that's applied
    animationOut: ["animated", "fadeOut"],    // animate.css classes that's applied
    width: 275,
    dismiss: {
      duration: 5000
    }
  });
}

function alertInfo(message) {
  store.addNotification({
    container: 'top-right',                   // where to position the notifications
    content: () => {
      return (
        <div className='flash flash-info'>
          {message}
        </div>
      );
    },                                        // skyframework flash alert
    animationIn: ["animated", "fadeIn"],      // animate.css classes that's applied
    animationOut: ["animated", "fadeOut"],    // animate.css classes that's applied
    dismiss: {
      duration: 3000
    }
  });
}

function alertWarning(message) {
  store.addNotification({
    container: 'top-right',                   // where to position the notifications
    content: () => {
      return (
        <div className='flash flash-warning'>
          {message}
        </div>
      );
    },                                        // skyframework flash alert
    animationIn: ["animated", "fadeIn"],      // animate.css classes that's applied
    animationOut: ["animated", "fadeOut"],    // animate.css classes that's applied
    dismiss: {
      duration: 3000
    }
  });
}

function alertError(message) {
  store.addNotification({
    container: 'top-right',                   // where to position the notifications
    content: () => {
      return (
        <div className='flash flash-error'>
          {message}
        </div>
      );
    },                                        // skyframework flash alert
    animationIn: ["animated", "fadeIn"],      // animate.css classes that's applied
    animationOut: ["animated", "fadeOut"],    // animate.css classes that's applied
    dismiss: {
      duration: 5000
    }
  });
}

export default (SkyNotification);
